export interface IOtpAuthGateState {
  isOtpCredentialLanding: boolean;
  isMounted: boolean;
  isOtpAuthSettled: boolean;
}

export const shouldRunOtpCredentialAuth = ({
  isOtpCredentialLanding,
  isMounted,
  isOtpAuthSettled,
}: IOtpAuthGateState): boolean => isOtpCredentialLanding && isMounted && !isOtpAuthSettled;

export const shouldHoldFullUi = ({
  isOtpCredentialLanding,
  isOtpAuthSettled,
}: IOtpAuthGateState): boolean => isOtpCredentialLanding && !isOtpAuthSettled;
